import React from 'react';
import moment from 'moment';
import Markdown from 'react-remarkable';
import { jsx, css } from '@emotion/core';

import Link from '../../../shared/Link/Link';
import Button from '../../../shared/Button/Button';

import './ListSinglePost.scss';
import { ImageDispatcher } from '../../../shared/ImageDispatcher/ImageDispatcher';

const shortenExcerpt = excerpt => {
  const trimmedString = excerpt.substr(
    0,
    Math.min(excerpt.length, excerpt.lastIndexOf(' '))
  );
  return trimmedString + '...';
};

const regex = /([^\d\w-]+)/g;

const ListSinglePost = props => {
  const { post, uiVariantButton } = props;

  const listPostStyle = css`
    &.variant-1 {
      a.img-link {
        .blog-image,
        .no-image {
          border-radius: 12px;
        }

        &:focus,
        &:hover {
          .mask {
            border-radius: 12px;
          }
        }
      }
    }

    &.variant-2 {
    }

    &.variant-3 {
      a.img-link {
        .blog-image,
        .no-image {
          border-radius: 6px;
        }

        &:focus,
        &:hover {
          .mask {
            border-radius: 6px;
          }
        }
      }
    }
  `;

  const cleanUrl = string => {
    return (string || '').replace(regex, '-');
  };

  return (
    <div
      className={`list-single-post variant-${uiVariantButton}`}
      css={listPostStyle}
    >
      <Link
        to={`/blog/${post.id}-${cleanUrl(post.title)}`}
        className="img-link"
        aria-label={`Leggi il nostro articole "${post.title}"`}
      >
        {!!post.featuredImageUrl ? (
          <ImageDispatcher
            alt={post.title}
            src={post.featuredImageUrl}
            className="img-fluid blog-image"
          />
        ) : (
          <div className="no-image" />
        )}
        <div className="mask">
          <Button className="btn btn-primary btn-thick">Leggi di più</Button>
        </div>
      </Link>

      <div className="date">{moment(post.date).format('DD MMMM YYYY')}</div>

      <h2>
        <Link
          to={`/blog/${post.id}-${cleanUrl(post.title)}`}
          className="title-link"
        >
          {post.title}
        </Link>
      </h2>

      <Markdown source={shortenExcerpt(post.excerpt)} />
    </div>
  );
};

export default ListSinglePost;
